import React, { useEffect, useState, useRef } from "react";
import img from "../../../img/team-1.jpg";
import { useLocation, useNavigate } from "react-router";
import useAxios from "../../../api/useAxios";
import mentor from "../../../img/mentorImage.png";
import Rating from "@mui/material/Rating";
import StarRateIcon from "@mui/icons-material/StarRate";
import ThumbsUpDownIcon from "@mui/icons-material/ThumbsUpDown";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { Box, Slider, CircularProgress, Backdrop } from "@mui/material";
import AvatarEditor from "react-avatar-editor";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { Buffer } from "buffer";
import Tooltip from "@mui/material/Tooltip";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import VerifiedIcon from '@mui/icons-material/Verified';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LanguageIcon from '@mui/icons-material/Language';
import BusinessIcon from '@mui/icons-material/Business';
import SchoolIcon from '@mui/icons-material/School';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import { alpha } from '@mui/material/styles';
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { Grid, Typography, DialogTitle, Tabs, Tab } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { saveAs } from "file-saver";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TextField from "@mui/material/TextField";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MentorAboutUs = () => {
  const Location = useLocation();
  const navigate = useNavigate();
  const axiosData = useAxios();
  const [getMentor, setGetMentor] = useState([]);
  const [noData, setNoData] = useState(false);
  const baseUrl = axiosData.defaults.baseURL;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState("");
  const [isFullContentDisplayed, setIsFullContentDisplayed] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const currentUrl = Location.pathname;

  let seekerData = JSON.parse(localStorage.getItem("seeker"));

  const [openRating, setOpenRating] = useState(false);
  const [ratingValue, setRatingValue] = useState(0);
  const [ratedValue, setRatedValue] = useState(0);
  const [ratingDescription, setRatingDescription] = useState("");

  const handleRating = async () => {
    try {
      const getOneAxios = await axiosData.put(
        `mentor/email/${Location.state?.email_id}`,
        { rating: ratingValue, ratingDescription: ratingDescription },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      getMentorData();
    } catch (error) {
      console.error("Error saving rating:", error);
    }
  };

  const getMentorData = async () => {
    try {
      const getOneAxios = await axiosData.get(
        `mentor/email/get/${Location.state?.email_id}`
      );
      const data = getOneAxios.data;
      setRatedValue(getOneAxios.data.rating);
      if (data) {
        if (Location.state?.usertype === "mentor") {
          const email_id = data.email_id;
          const MentorName = data.MentorName;

          localStorage.setItem(
            "mentor",
            JSON.stringify({ email_id, MentorName })
          );
        }
        setGetMentor(data);
        setContent(data.Experience);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const toggleContentDisplay = () => {
    setIsFullContentDisplayed(!isFullContentDisplayed);
  };

  useEffect(() => {
    let mentorDetails = JSON.parse(localStorage.getItem("mentor"));
    if (Location.state?.usertype === "mentor") {
      if (
        currentUrl ===
        ROUTINGDATA.LAND + ROUTINGDATA.MAIN + ROUTINGDATA.MENTORProfile
      ) {
        getMentorData();
      } else {
        if (mentorDetails === null || mentorDetails === undefined) {
          navigate(
            `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.PageNotFound}`
          );
        } else {
          getMentorData();
        }
      }
    } else {
      getMentorData();
    }
  }, []);

  const [image, setimage] = useState();
  const [open, setOpen] = useState(false);
  const [ref, setr] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  var editor = "";
  const [picture, setPicture] = useState({
    cropperOpen: false,
    img: null,
    zoom: 2,
    croppedImg: " ",
  });

  const handleSlider = (event, value) => {
    setPicture({
      ...picture,
      zoom: value,
    });
  };

  const handleCancel = () => {
    setPicture({
      ...picture,
      cropperOpen: false,
    });
  };

  const setEditorRef = (ed) => {
    editor = ed;
  };
  function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async (e, Context) => {
    if (setEditorRef) {
      const canvasScaled = editor.getImageScaledToCanvas();
      const croppedImg = canvasScaled.toDataURL();

      if (croppedImg) {
        setPicture({
          ...picture,
          img: null,
          cropperOpen: false,
          croppedImg: croppedImg,
        });
      }

      var block = croppedImg.split(";");

      var contentType = block[0].split(":")[1];
      var realData = block[1].split(",")[1];
      const img = b64toBlob(realData, contentType);

      const values = { mentorProfile: "" };
      if (picture) {
        fileInputField.current.value = "";
        values.mentorProfile = img;
        try {
          const response = await axiosData.delete(
            `mentor/get/profile/${Location.state.email_id}`,
            values,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        } catch (err) {
          console.log(err);
        }

        setIsLoading(true);

        const response = await axiosData.put(
          `mentor/email/${Location.state.email_id}`,
          values,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response) {
          setimage(null);
          setOpen(false);
          setr(true);
        }
      }
    }
  };
  const fileInputField = useRef(null);

  const [imageSize, setImageSize] = useState(false);

  const handleFileChange = (e) => {
    let imgFile = e.target.files[0];

    // Check if a file is selected
    if (!imgFile) {
      return;
    }

    // Check if the file size is less than 2MB
    const maxSize = 5 * 1024 * 1024; // 2MB in bytes
    if (imgFile.size > maxSize) {
      // Handle the case when the image exceeds the size limit
      setImageSize(true);
      fileInputField.current.value = "";
      return;
    }

    // If the file is valid, proceed with setting the state
    handleClickOpen();
    setPicture({
      ...picture,
      img: imgFile,
      cropperOpen: true,
    });
  };

  const fun = async () => {
    const response = await axiosData.get(
      `mentor/email/get/${Location.state.email_id}`
    );

    if (response.data) {
      try {
        const response1 = await axiosData.get(
          `mentor/get/profile/${response.data.email_id}`,
          {
            responseType: "arraybuffer",
          }
        );

        const docBuffer = Buffer.from(response1.data, "binary");
        const docDataUrl = URL.createObjectURL(new Blob([docBuffer]));

        setimage(docDataUrl);
      } catch (error) {
        console.error(error);
      }
      setr(false);
    }
    setIsLoading(false);
    setIsLoading(false);
  };
  const [isDelete, setIsDelete] = useState(false);
  const [deleteResume, setDeleteResume] = useState(false);
  const [resumeUpload, setResumeUpload] = useState(false);
  const [resume, setResume] = useState("");

  const MAX_FILE_SIZE = 1048576 * 10; //10Mb
  const cvInputField = useRef(null);

  const CVhandleFileChange = async (e) => {
    if (e.target.files[0].size > MAX_FILE_SIZE) {
      setResumeUpload(true);
      setResume("");
      cvInputField.current.value = "";
    } else {
      setResume({ CVUpload: e.target.files[0] });

      const values = { CVUpload: "" };
      if (e.target.files[0]) {
        values.CVUpload = e.target.files[0];
      }
      setIsSubmitting(true);
      await axiosData.put(`/mentor/email/${Location.state.email_id}`, values, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      getMentorData();
      setIsSubmitting(false);
      cvInputField.current.value = "";
    }
  };

  useEffect(() => {
    setIsLoading(true);
    setimage(null);
    setTimeout(() => {
      if (Location.state !== undefined) {
        fun();
      } else {
        setr(true);
      }
    }, 1000);

    setr(false);
  }, [ref]);
  if (getMentor) {
    return (
      <div style={{ height: "100%" }}>
        <Dialog
          TransitionComponent={Transition}
          open={imageSize}
          sx={{ "& .MuiPaper-root": { width: "500px" } }}
        >
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            <WarningAmberOutlinedIcon sx={{ mb: -0.5 }} /> Photo Upload Limit
          </DialogTitle>
          <DialogContent sx={{ mt: 1 }}>
            <DialogContentText sx={{ fontWeight: 600, mt: 2 }}>
              Note: Image file size exceeds the allowed limit of 2MB. Please
              choose a smaller size image.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => setImageSize(false)}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          TransitionComponent={Transition}
          open={deleteResume}
          sx={{ "& .MuiPaper-root": { color: "white", width: "400px" } }}
        >
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ backgroundColor: "rgb(16 143 178)", fontWeight: 600 }}
          >
            Delete CV
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              Are you sure, you want to delete CV
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={() => {
                setDeleteResume(false);
              }}
            >
              No
            </Button>
            <Button
              color="primary"
              variant="contained"
              disabled={isDelete}
              onClick={async () => {
                setIsDelete(true);
                await axiosData.delete(`/mentor/cv/${getMentor.email_id}`);
                getMentorData();
                setIsDelete(false);
                setDeleteResume(false);
              }}
            >
              Yes{" "}
              {isDelete && (
                <CircularProgress
                  size={24}
                  style={{
                    color: "#ffffff",
                    marginLeft: "4px",
                    marginBottom: "-2px",
                  }}
                />
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog TransitionComponent={Transition} open={resumeUpload}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            CV Upload
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {"File size is too large upload < 10MB file."}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setResumeUpload(false)}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          TransitionComponent={Transition}
          open={openRating}
          sx={{ "& .MuiPaper-root": { width: "500px" } }}
        >
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            <ThumbsUpDownIcon sx={{ mb: -0.5, mr: 0.8 }} />
            Rate This Mentor
          </DialogTitle>
          <DialogContent sx={{ mt: 1 }}>
            <DialogContentText sx={{ fontWeight: 600, mt: 2 }}>
              <Typography sx={{ mb: 1 }}>
                Reviews are public and include your account and device info
              </Typography>
              <Rating
                name="half-rating"
                sx={{ fontSize: "35px" }}
                value={ratingValue}
                precision={0.5}
                onChange={(event, newValue) => {
                  setRatingValue(newValue);
                }}
              />

              <TextField
                required
                fullWidth
                placeholder="Describe your experience (optional)"
                id="ratingDescription"
                name="ratingDescription"
                onChange={(e) => {
                  if (e) {
                    if (e.target.value.length <= 200) {
                      const value = e.target.value.replace(/[^a-z.,' ]/gi, "");
                      setRatingDescription(value);
                    }
                  }
                }}
                value={ratingDescription}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={() => setOpenRating(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleRating();
                setOpenRating(false);
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        {/* ====== PREMIUM HERO HEADER ====== */}
        <div className="mentoraboutuspageheader" style={{ position: 'relative', overflow: 'hidden' }}>

          {/* Back / Edit buttons */}
          <div className="backbuttonformentor" style={{ position: 'relative', zIndex: 10 }}>
            <Tooltip title="Go Back" arrow>
              <IconButton
                onClick={() => navigate("/main/mentor")}
                sx={{
                  bgcolor: 'rgba(255,255,255,0.12)',
                  backdropFilter: 'blur(12px)',
                  color: 'white',
                  border: '1.5px solid rgba(255,255,255,0.25)',
                  width: 42, height: 42,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.22)', transform: 'scale(1.08)' },
                  transition: 'all 0.25s ease',
                }}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: '17px' }} />
              </IconButton>
            </Tooltip>

            {Location.state && Location.state.usertype === "mentor" ? (
              <Tooltip title="Edit Profile" arrow>
                <IconButton
                  className="editbutton-mentor"
                  onClick={() => setOpen(true)}
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.12)',
                    backdropFilter: 'blur(12px)',
                    color: 'white',
                    border: '1.5px solid rgba(255,255,255,0.25)',
                    width: 42, height: 42,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.22)', transform: 'scale(1.08)' },
                    transition: 'all 0.25s ease',
                  }}
                >
                  <EditIcon className="iconedit" sx={{ fontSize: '18px' }} />
                </IconButton>
              </Tooltip>
            ) : null}
          </div>

          {/* Mentor Identity */}
          <div className="mentorpage" style={{ alignItems: 'center', position: 'relative', zIndex: 10 }}>

            {/* Avatar */}
            <div className="mentorpage-imgpart">
              <div style={{
                position: 'relative',
                width: '160px', height: '160px',
                flexShrink: 0,
              }}>
                {/* Glowing spinning ring */}
                <div style={{
                  position: 'absolute', inset: '-5px',
                  borderRadius: '50%',
                  background: 'conic-gradient(from 0deg, #108fb2, #38bdf8, #0c6a85, #108fb2)',
                  animation: 'spin 8s linear infinite',
                  opacity: 0.85,
                }} />
                {/* Dark gap ring */}
                <div style={{
                  position: 'absolute', inset: '2px',
                  borderRadius: '50%',
                  background: 'rgba(15,23,42,0.9)',
                }} />

                {/* Profile picture + Upload overlay — both clipped inside the circle */}
                <div
                  style={{
                    position: 'absolute',
                    inset: '5px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#e2e8f0',
                  }}
                >
                  <img
                    src={getMentor.mentorProfile
                      ? `${baseUrl}mentor/get/profile/${getMentor.email_id}`
                      : (Location.state?.userimage || mentor)}
                    onError={(e) => { e.target.onerror = null; e.target.src = mentor; }}
                    alt={getMentor.MentorName || 'Mentor'}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center top',
                      display: 'block',
                    }}
                  />
                  {/* Upload hover overlay — only for mentors */}
                  {Location.state?.usertype === "mentor" && (
                    <div
                      onClick={() => fileInputField.current.click()}
                      style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(16, 143, 178, 0.55)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        paddingBottom: '14px',
                        cursor: 'pointer',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                      onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
                    >
                      <span style={{ color: 'white', fontSize: '12px', fontWeight: 700, letterSpacing: '0.5px', textShadow: '0 1px 4px rgba(0,0,0,0.4)' }}>
                        📷 Upload
                      </span>
                    </div>
                  )}
                </div>

                {/* Verified badge */}
                <div style={{
                  position: 'absolute',
                  bottom: '6px', right: '2px',
                  background: 'linear-gradient(135deg, #108fb2, #0c6a85)',
                  borderRadius: '50%',
                  padding: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid white',
                  boxShadow: '0 4px 12px rgba(16,143,178,0.5)',
                  zIndex: 10,
                }}>
                  <VerifiedIcon style={{ color: 'white', fontSize: '15px' }} />
                </div>
              </div>
            </div>


            {/* Name & badges */}
            <div className="mentorname">
              <h4 style={{ fontSize: '34px', fontWeight: 800, letterSpacing: '-0.8px', textShadow: '0 2px 20px rgba(0,0,0,0.3)', marginBottom: '4px' }}>
                {getMentor.MentorName || 'Mentor Name'}
              </h4>
              {getMentor.Designation && (
                <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '14px', fontWeight: 500, mb: 1.5, letterSpacing: '0.3px' }}>
                  {getMentor.Designation}{getMentor.currentEmployer ? ` · ${getMentor.currentEmployer}` : ''}
                </Typography>
              )}
              <Box sx={{ display: 'flex', gap: 1.5, mt: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                <Box sx={{
                  display: 'flex', alignItems: 'center', gap: 0.8,
                  bgcolor: 'rgba(16,143,178,0.25)',
                  backdropFilter: 'blur(8px)',
                  px: 2, py: 0.6,
                  borderRadius: '20px',
                  border: '1px solid rgba(56,189,248,0.4)',
                  boxShadow: '0 0 12px rgba(16,143,178,0.25)',
                }}>
                  <WorkspacePremiumIcon sx={{ color: '#38bdf8', fontSize: '15px' }} />
                  <Typography sx={{ color: 'white', fontSize: '11px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase' }}>
                    EXPLORER
                  </Typography>
                </Box>

                {getMentor.createdDate && (
                  <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 0.8,
                    bgcolor: 'rgba(255,255,255,0.1)',
                    backdropFilter: 'blur(8px)',
                    px: 2, py: 0.6,
                    borderRadius: '20px',
                    border: '1px solid rgba(255,255,255,0.15)',
                  }}>
                    <CalendarMonthIcon sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }} />
                    <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '11px', fontWeight: 500, letterSpacing: '0.3px' }}>
                      Joined {getMentor.createdDate}
                    </Typography>
                  </Box>
                )}

                {getMentor.areaOfExpertise && (
                  <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 0.8,
                    bgcolor: 'rgba(139,92,246,0.2)',
                    backdropFilter: 'blur(8px)',
                    px: 2, py: 0.6,
                    borderRadius: '20px',
                    border: '1px solid rgba(139,92,246,0.35)',
                  }}>
                    <Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '11px', fontWeight: 600 }}>
                      🎯 {getMentor.areaOfExpertise}
                    </Typography>
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </div>
        <div className="MentorBox" style={{
          width: '100%',
          background: 'linear-gradient(180deg, #f0f9ff 0%, #f8fafc 100%)',
          padding: '0 40px 60px 40px',
          boxSizing: 'border-box',
          minHeight: '60vh',
        }}>
          {/* Tabs */}
          <Box sx={{ width: '100%', pt: 4, pb: 3, display: 'flex', justifyContent: 'center' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                minHeight: '48px',
                bgcolor: 'rgba(241, 245, 249, 0.8)',
                backdropFilter: 'blur(10px)',
                borderRadius: '32px',
                p: '6px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                '& .MuiTabs-indicator': {
                  height: '100%',
                  borderRadius: '26px',
                  bgcolor: 'white',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  zIndex: 0,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                },
                '& .MuiTabs-flexContainer': {
                  gap: '4px',
                },
              }}
            >
              {[
                "About",
                "Personal Details",
                "Education",
                "Professional",
                "Reviews"
              ].map((label, index) => (
                <Tab
                  key={label}
                  label={label}
                  sx={{
                    minHeight: '36px',
                    borderRadius: '26px',
                    textTransform: 'none',
                    fontSize: '14px',
                    fontWeight: tabValue === index ? '700' : '500',
                    color: tabValue === index ? '#0f172a' : '#64748b',
                    px: 4,
                    zIndex: 1,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      color: tabValue === index ? '#0f172a' : '#1e293b',
                      bgcolor: tabValue === index ? 'transparent' : 'rgba(255, 255, 255, 0.5)',
                    },
                    '&.Mui-selected': {
                      color: '#0f172a',
                    }
                  }}
                />
              ))}
            </Tabs>
          </Box>

          <div className="mentorbox-tab-content" style={{ paddingBottom: '40px' }}>
            {tabValue === 0 && (
              <Box className="combianbox" sx={{
                border: 'none',
                boxShadow: '0 4px 24px -4px rgba(0,0,0,0.08), 0 2px 8px -2px rgba(16,143,178,0.06)',
                background: 'linear-gradient(135deg,#ffffff 0%,#f8fcff 100%)',
              }}>
                {/* Section header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#108fb2,#38bdf8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px -4px rgba(16,143,178,0.4)' }}>
                    <HistoryEduIcon sx={{ color: 'white', fontSize: '22px' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.3px' }}>About</Typography>
                    <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>Mentor's background &amp; bio</Typography>
                  </Box>
                </Box>
                {getMentor.Experience ? (
                  <Box sx={{ background: 'linear-gradient(135deg,rgba(16,143,178,0.04),rgba(56,189,248,0.06))', borderRadius: '14px', p: 3, borderLeft: '4px solid #108fb2', position: 'relative' }}>
                    <div
                      dangerouslySetInnerHTML={{ __html: getMentor.Experience }}
                      style={{ color: '#374151', lineHeight: 1.9, fontSize: '15px' }}
                    />
                  </Box>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 6, color: '#94a3b8' }}>
                    <Typography sx={{ fontSize: '40px', mb: 1 }}>📝</Typography>
                    <Typography sx={{ fontStyle: 'italic', fontSize: '15px' }}>No information provided yet.</Typography>
                  </Box>
                )}
              </Box>
            )}

            {tabValue === 1 && (
              <Box className="combianbox" sx={{
                border: 'none',
                boxShadow: '0 4px 24px -4px rgba(0,0,0,0.08), 0 2px 8px -2px rgba(16,143,178,0.06)',
                background: 'linear-gradient(135deg,#ffffff 0%,#f8fcff 100%)',
              }}>
                {/* Section header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#0ea5e9,#38bdf8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px -4px rgba(14,165,233,0.4)' }}>
                    <BusinessIcon sx={{ color: 'white', fontSize: '22px' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.3px' }}>Personal Information</Typography>
                    <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>Contact &amp; location details</Typography>
                  </Box>
                </Box>

                {/* Cards grid */}
                <Grid container spacing={3}>
                  {[
                    { icon: <EmailIcon />, label: 'Email Address', value: getMentor.email_id, gradFrom: '#0ea5e9', gradTo: '#38bdf8', shadowColor: 'rgba(14,165,233,0.3)' },
                    { icon: <PhoneIphoneIcon />, label: 'Phone Number', value: getMentor.mobileNumber, gradFrom: '#10b981', gradTo: '#34d399', shadowColor: 'rgba(16,185,129,0.3)' },
                    { icon: <LocationOnIcon />, label: 'Current Location', value: getMentor.currentLocation, gradFrom: '#f59e0b', gradTo: '#fbbf24', shadowColor: 'rgba(245,158,11,0.3)' },
                    { icon: <LanguageIcon />, label: 'State / Country', value: `${getMentor.state || ''}${getMentor.state && getMentor.country ? ', ' : ''}${getMentor.country || ''}`, gradFrom: '#8b5cf6', gradTo: '#a78bfa', shadowColor: 'rgba(139,92,246,0.3)' },
                  ].map((field) => (
                    <Grid item xs={12} sm={6} key={field.label}>
                      <Box sx={{
                        p: 3, borderRadius: '16px',
                        background: '#f8fafc',
                        border: '1px solid #f1f5f9',
                        display: 'flex', alignItems: 'flex-start', gap: 2.5,
                        transition: 'all 0.25s ease',
                        '&:hover': { background: 'white', boxShadow: `0 12px 28px -6px ${field.shadowColor}`, transform: 'translateY(-3px)', borderColor: 'transparent' }
                      }}>
                        <Box sx={{ width: 48, height: 48, borderRadius: '14px', background: `linear-gradient(135deg,${field.gradFrom},${field.gradTo})`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: `0 6px 14px -4px ${field.shadowColor}` }}>
                          {React.cloneElement(field.icon, { sx: { fontSize: '22px', color: 'white' } })}
                        </Box>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography sx={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', color: '#94a3b8', mb: 0.5 }}>{field.label}</Typography>
                          <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#0f172a', wordBreak: 'break-word', lineHeight: 1.4 }}>{field.value || '—'}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}


            {tabValue === 2 && (
              <Box className="combianbox" sx={{
                border: 'none',
                boxShadow: '0 4px 24px -4px rgba(0,0,0,0.08), 0 2px 8px -2px rgba(16,143,178,0.06)',
                background: 'linear-gradient(135deg,#ffffff 0%,#f8fcff 100%)',
              }}>
                {/* Section header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#6366f1,#818cf8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px -4px rgba(99,102,241,0.4)' }}>
                    <SchoolIcon sx={{ color: 'white', fontSize: '22px' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.3px' }}>Educational Background</Typography>
                    <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>Qualifications &amp; academic profile</Typography>
                  </Box>
                </Box>

                <Grid container spacing={3}>
                  {[
                    { label: 'Education Qualifications', value: getMentor.educationQualifications, icon: '🎓', gradFrom: '#6366f1', gradTo: '#818cf8', shadow: 'rgba(99,102,241,0.25)', desc: 'Highest degree attained' },
                    { label: 'Specialisation', value: getMentor.Specialisation, icon: '📚', gradFrom: '#0ea5e9', gradTo: '#38bdf8', shadow: 'rgba(14,165,233,0.25)', desc: 'Area of study / subject' },
                    { label: 'LinkedIn Profile', value: getMentor.linkedInLink, icon: '💼', gradFrom: '#3b82f6', gradTo: '#60a5fa', shadow: 'rgba(59,130,246,0.25)', desc: 'Professional network link', isLink: true },
                  ].map((field) => (
                    <Grid item xs={12} sm={6} key={field.label}>
                      <Box sx={{
                        p: 3, borderRadius: '16px',
                        background: '#f8fafc',
                        border: '1px solid #f1f5f9',
                        height: '100%',
                        transition: 'all 0.25s ease',
                        '&:hover': { background: 'white', boxShadow: `0 12px 28px -6px ${field.shadow}`, transform: 'translateY(-3px)', borderColor: 'transparent' }
                      }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                          <Box sx={{ width: 40, height: 40, borderRadius: '11px', background: `linear-gradient(135deg,${field.gradFrom},${field.gradTo})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', boxShadow: `0 6px 12px -4px ${field.shadow}`, flexShrink: 0 }}>
                            {field.icon}
                          </Box>
                          <Box>
                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#0f172a' }}>{field.label}</Typography>
                            <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>{field.desc}</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ background: `linear-gradient(135deg,${field.gradFrom}10,${field.gradTo}18)`, borderRadius: '10px', px: 2, py: 1.5, borderLeft: `3px solid ${field.gradFrom}` }}>
                          {field.isLink && field.value ? (
                            <a href={field.value} target="_blank" rel="noopener noreferrer" style={{ color: field.gradFrom, fontWeight: 700, fontSize: '14px', wordBreak: 'break-all', textDecoration: 'none' }}>
                              {field.value}
                            </a>
                          ) : (
                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1e293b', wordBreak: 'break-word' }}>{field.value || '—'}</Typography>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}


            {tabValue === 3 && (
              <Box className="combianbox" sx={{
                border: 'none',
                boxShadow: '0 4px 24px -4px rgba(0,0,0,0.08), 0 2px 8px -2px rgba(16,143,178,0.06)',
                background: 'linear-gradient(135deg,#ffffff 0%,#f8fcff 100%)',
              }}>
                {/* Section header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#f59e0b,#fbbf24)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px -4px rgba(245,158,11,0.4)' }}>
                    <BusinessIcon sx={{ color: 'white', fontSize: '22px' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.3px' }}>Professional Experience</Typography>
                    <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>Career &amp; expertise summary</Typography>
                  </Box>
                </Box>

                {/* Highlight stat strip */}
                <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
                  {getMentor.yearsOfExperience && (
                    <Box sx={{ flex: 1, minWidth: '140px', background: 'linear-gradient(135deg,#0ea5e9,#38bdf8)', borderRadius: '14px', p: 2.5, textAlign: 'center', boxShadow: '0 8px 20px -6px rgba(14,165,233,0.5)' }}>
                      <Typography sx={{ fontSize: '32px', fontWeight: 900, color: 'white', lineHeight: 1 }}>{getMentor.yearsOfExperience}</Typography>
                      <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.85)', fontWeight: 600, mt: 0.5, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Years of Experience</Typography>
                    </Box>
                  )}
                  {getMentor.areaOfExpertise && (
                    <Box sx={{ flex: 2, minWidth: '200px', background: 'linear-gradient(135deg,#8b5cf6,#a78bfa)', borderRadius: '14px', p: 2.5, display: 'flex', alignItems: 'center', gap: 2, boxShadow: '0 8px 20px -6px rgba(139,92,246,0.4)' }}>
                      <Typography sx={{ fontSize: '28px' }}>🎯</Typography>
                      <Box>
                        <Typography sx={{ fontSize: '11px', color: 'rgba(255,255,255,0.8)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Area of Expertise</Typography>
                        <Typography sx={{ fontSize: '16px', fontWeight: 800, color: 'white', mt: 0.3 }}>{getMentor.areaOfExpertise}</Typography>
                      </Box>
                    </Box>
                  )}
                </Box>

                {/* Main cards */}
                <Grid container spacing={3}>
                  {[
                    { label: 'Current Designation', value: getMentor.Designation, icon: '💼', gradFrom: '#f59e0b', gradTo: '#fbbf24', shadow: 'rgba(245,158,11,0.25)', desc: 'Job title / role' },
                    { label: 'Current Employer', value: getMentor.currentEmployer, icon: '🏢', gradFrom: '#10b981', gradTo: '#34d399', shadow: 'rgba(16,185,129,0.25)', desc: 'Company or organisation' },
                    { label: 'Current Location', value: getMentor.officialAddress, icon: '🏫', gradFrom: '#6366f1', gradTo: '#818cf8', shadow: 'rgba(99,102,241,0.25)', desc: 'Office / work location' },
                    { label: 'Membership in Professional', value: getMentor.membershipInProfessional, icon: '🏅', gradFrom: '#0ea5e9', gradTo: '#38bdf8', shadow: 'rgba(14,165,233,0.25)', desc: 'Professional societies / associations' },
                    { label: 'Professional Certifications', value: getMentor.professionalCertifications, icon: '📜', gradFrom: '#f43f5e', gradTo: '#fb7185', shadow: 'rgba(244,63,94,0.25)', desc: 'Certifications & trainings' },
                  ].map((field) => (
                    <Grid item xs={12} sm={6} key={field.label}>
                      <Box sx={{
                        p: 3, borderRadius: '16px',
                        background: '#f8fafc',
                        border: '1px solid #f1f5f9',
                        height: '100%',
                        transition: 'all 0.25s ease',
                        '&:hover': { background: 'white', boxShadow: `0 12px 28px -6px ${field.shadow}`, transform: 'translateY(-3px)', borderColor: 'transparent' }
                      }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                          <Box sx={{ width: 42, height: 42, borderRadius: '12px', background: `linear-gradient(135deg,${field.gradFrom},${field.gradTo})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', boxShadow: `0 6px 12px -4px ${field.shadow}`, flexShrink: 0 }}>
                            {field.icon}
                          </Box>
                          <Box>
                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#0f172a' }}>{field.label}</Typography>
                            <Typography sx={{ fontSize: '11px', color: '#94a3b8' }}>{field.desc}</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ background: `linear-gradient(135deg,${field.gradFrom}10,${field.gradTo}18)`, borderRadius: '10px', px: 2, py: 1.5, borderLeft: `3px solid ${field.gradFrom}` }}>
                          <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#1e293b', wordBreak: 'break-word' }}>{field.value || '—'}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}


            {tabValue === 4 && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                {/* ── RATING CARD ── */}
                <Box className="combianbox" sx={{
                  border: 'none',
                  boxShadow: '0 4px 24px -4px rgba(0,0,0,0.08), 0 2px 8px -2px rgba(16,143,178,0.08)',
                  background: 'linear-gradient(135deg,#ffffff 0%,#f0f9ff 100%)',
                  p: 0, overflow: 'hidden',
                }}>
                  {/* Section header */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: '28px 32px 24px 32px', flexWrap: 'wrap', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#108fb2,#38bdf8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px -4px rgba(16,143,178,0.4)' }}>
                        <StarRateIcon sx={{ color: 'white', fontSize: '22px' }} />
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.3px' }}>Reviews &amp; Ratings</Typography>
                        <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>What the community says</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ px: 2, py: 0.6, borderRadius: '20px', background: 'rgba(16,143,178,0.1)', border: '1px solid rgba(16,143,178,0.25)' }}>
                      <Typography sx={{ fontSize: '12px', color: '#108fb2', fontWeight: 700 }}>0 total reviews</Typography>
                    </Box>
                  </Box>

                  {/* Rating content */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, px: '32px', pb: '28px', flexWrap: 'wrap' }}>
                    {/* Big score circle */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 110, height: 110, borderRadius: '50%', background: 'linear-gradient(135deg,#e0f2fe,#bae6fd)', border: '3px solid #7dd3fc', boxShadow: '0 8px 24px -6px rgba(16,143,178,0.3)', flexShrink: 0 }}>
                      <Typography sx={{ fontSize: '40px', fontWeight: 900, color: '#0c6a85', lineHeight: 1 }}>0</Typography>
                      <Typography sx={{ fontSize: '11px', color: '#0c6a85', fontWeight: 600, mt: 0.3 }}>/ 5.0</Typography>
                    </Box>

                    {/* Divider */}
                    <Box sx={{ width: '1px', height: '90px', background: 'linear-gradient(to bottom,transparent,#e2e8f0,transparent)', display: { xs: 'none', sm: 'block' } }} />

                    {/* Star breakdown bars */}
                    <Box sx={{ flex: 1, minWidth: '180px', display: 'flex', flexDirection: 'column', gap: 1.2 }}>
                      {[5, 4, 3, 2, 1].map((star) => (
                        <Box key={star} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                          <Typography sx={{ fontSize: '11px', color: '#64748b', fontWeight: 600, width: '12px', textAlign: 'right' }}>{star}</Typography>
                          <StarRateIcon sx={{ fontSize: '13px', color: '#facc15' }} />
                          <Box sx={{ flex: 1, height: '8px', borderRadius: '4px', background: '#f1f5f9', overflow: 'hidden' }}>
                            <Box sx={{ width: '0%', height: '100%', borderRadius: '4px', background: 'linear-gradient(90deg,#108fb2,#38bdf8)' }} />
                          </Box>
                          <Typography sx={{ fontSize: '11px', color: '#94a3b8', width: '18px' }}>0</Typography>
                        </Box>
                      ))}
                    </Box>

                    {/* Stars display */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                      <Rating value={0} readOnly precision={0.5} sx={{ color: '#facc15', fontSize: '24px' }} />
                      <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>No reviews yet</Typography>
                    </Box>
                  </Box>

                  {/* Rate CTA */}
                  {Location.state?.usertype !== "mentor" && (
                    <Box
                      onClick={() => setOpenRating(true)}
                      sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2,
                        py: 2.5, cursor: 'pointer',
                        background: 'linear-gradient(90deg,#f0f9ff,#e0f2fe,#f0f9ff)',
                        borderTop: '1px solid #bae6fd',
                        transition: 'all 0.25s ease',
                        '&:hover': { background: 'linear-gradient(90deg,#e0f2fe,#bae6fd,#e0f2fe)' }
                      }}
                    >
                      <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'linear-gradient(135deg,#108fb2,#38bdf8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(16,143,178,0.4)' }}>
                        <ThumbsUpDownIcon sx={{ fontSize: '16px', color: 'white' }} />
                      </Box>
                      <Typography sx={{ color: '#0c6a85', fontWeight: 800, fontSize: '15px' }}>Rate This Mentor</Typography>
                      <Typography sx={{ color: '#108fb2', fontSize: '16px' }}>{'→'}</Typography>
                    </Box>
                  )}
                </Box>

                {/* ── JOIN DATE CARD ── */}
                {getMentor.createdDate && (
                  <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 2.5, p: 2.5,
                    borderRadius: '16px', background: 'white',
                    border: '1px solid #f1f5f9',
                    boxShadow: '0 4px 16px -4px rgba(16,143,178,0.1)',
                    transition: 'all 0.2s ease',
                    '&:hover': { boxShadow: '0 8px 24px -6px rgba(16,143,178,0.18)', transform: 'translateY(-2px)' }
                  }}>
                    <Box sx={{ width: 48, height: 48, borderRadius: '14px', background: 'linear-gradient(135deg,#108fb2,#38bdf8)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0, boxShadow: '0 6px 14px -4px rgba(16,143,178,0.45)' }}>🗓</Box>
                    <Box>
                      <Typography sx={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', color: '#94a3b8', mb: 0.3 }}>Member Since</Typography>
                      <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#0f172a' }}>Joined VelaiVendum.com</Typography>
                      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#108fb2', mt: 0.2 }}>{getMentor.createdDate}</Typography>
                    </Box>
                  </Box>
                )}

                {/* ── CV SECTION (mentor only) ── */}
                {Location.state?.usertype === "mentor" && (
                  <Box sx={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 8px 32px -8px rgba(16,185,129,0.15)', border: '1px solid rgba(16,185,129,0.15)', background: 'white' }}>
                    {/* Green header */}
                    <Box sx={{ p: '24px 28px 20px 28px', background: 'linear-gradient(135deg,#ecfdf5,#f0fdf9)', borderBottom: '1px solid rgba(16,185,129,0.12)' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#10b981,#34d399)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px -4px rgba(16,185,129,0.4)' }}>
                          <DriveFolderUploadIcon sx={{ color: 'white', fontSize: '22px' }} />
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#064e3b', letterSpacing: '-0.3px' }}>CV / Resume</Typography>
                          <Typography sx={{ fontSize: '12px', color: '#6ee7b7', fontWeight: 500 }}>Upload &amp; manage your resume</Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box sx={{ p: '20px 28px 24px 28px' }}>
                      {/* Current file or warning */}
                      {getMentor.CVUpload && getMentor.CVUpload !== "" ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2.5, borderRadius: '12px', background: 'linear-gradient(135deg,rgba(16,185,129,0.06),rgba(52,211,153,0.1))', border: '1px solid rgba(16,185,129,0.2)', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography sx={{ fontSize: '28px' }}>📄</Typography>
                            <Box>
                              <Typography sx={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', color: '#94a3b8', letterSpacing: '0.6px' }}>Current CV</Typography>
                              <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#10b981' }}>{getMentor?.CVUpload?.name}</Typography>
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Tooltip title="Download CV" arrow>
                              <IconButton onClick={() => saveAs(`${baseUrl}mentor/get/cv/${getMentor.email_id}`, getMentor.CVUpload.name)} sx={{ bgcolor: 'rgba(16,185,129,0.1)', color: '#10b981', border: '1px solid rgba(16,185,129,0.25)', '&:hover': { bgcolor: 'rgba(16,185,129,0.2)' } }}>
                                <FileDownloadOutlinedIcon sx={{ fontSize: '18px' }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete CV" arrow>
                              <IconButton onClick={() => setDeleteResume(true)} sx={{ bgcolor: 'rgba(239,68,68,0.08)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.2)', '&:hover': { bgcolor: 'rgba(239,68,68,0.15)' } }}>
                                <DeleteIcon sx={{ fontSize: '18px' }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, borderRadius: '10px', background: '#fef3c7', border: '1px solid #fde68a', mb: 3 }}>
                          <Typography sx={{ fontSize: '20px' }}>⚠️</Typography>
                          <Typography sx={{ fontSize: '13px', color: '#92400e', fontWeight: 600 }}>No CV uploaded yet. Upload one below to get started!</Typography>
                        </Box>
                      )}

                      {/* Drop zone */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, borderRadius: '14px', background: 'linear-gradient(135deg,#f8fafc,#f0fdf9)', border: '2px dashed #a7f3d0', gap: 1, textAlign: 'center', transition: 'border-color 0.2s', '&:hover': { borderColor: '#10b981' } }}>
                        <input id="file-upload" type="file" accept=".docx,.doc,.pdf," onChange={CVhandleFileChange} ref={cvInputField} style={{ display: 'none' }} />
                        <Typography sx={{ fontSize: '32px', mb: 0.5 }}>☁️</Typography>
                        <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#064e3b' }}>Drag &amp; drop or choose a file</Typography>
                        <Typography sx={{ fontSize: '12px', color: '#6b7280' }}>.pdf, .doc, .docx supported — Max 10 MB</Typography>
                        <Button
                          disabled={!!getMentor.CVUpload}
                          variant="contained"
                          sx={{ background: 'linear-gradient(135deg,#10b981,#059669)', borderRadius: '10px', textTransform: 'none', fontWeight: 700, mt: 1.5, px: 4, boxShadow: '0 6px 16px -4px rgba(16,185,129,0.45)', '&:hover': { background: 'linear-gradient(135deg,#059669,#047857)', boxShadow: '0 8px 20px -4px rgba(16,185,129,0.55)' } }}
                          onClick={() => cvInputField.current.click()}
                          startIcon={<DriveFolderUploadIcon />}
                        >
                          Choose File
                          {isSubmitting && <CircularProgress size={18} style={{ color: 'white', marginLeft: 8 }} />}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </div>
        </div>
        <input
          ref={fileInputField}
          style={{ display: "none" }}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
        />

        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {picture.cropperOpen && (
                <Box display="block">
                  <AvatarEditor
                    ref={setEditorRef}
                    image={picture.img}
                    width={200}
                    height={200}
                    border={20}
                    color={[255, 255, 255, 0.6]}
                    rotate={0}
                    scale={picture.zoom}
                  />
                  <Slider
                    aria-label="raceSlider"
                    value={picture.zoom}
                    min={1}
                    max={10}
                    step={0.1}
                    onChange={handleSlider}
                  ></Slider>
                </Box>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleCancel();
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleSave();
                handleClose();
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div >
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div className="dots"></div>
      </div>
    );
  }
};

export default MentorAboutUs;
